import type { SxProps } from '@mui/material/styles';

export const TOPBAR_HEIGHT = 75;
export const SIDEBAR_WIDTH = 270;

export const buttonBaseStyle: SxProps = {
  width: 250,
  height: 50,
  mt: 6,
  borderRadius: 125,
  fontSize: 20,
};
